import styled from "@emotion/styled";
import MenuItem from "@mui/material/MenuItem";

export const StyledContainer = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(4),
}));

export const StyledOption = styled("span")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
}));

export const StyledContent = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    whiteSpace: "normal",
    padding: theme.spacing(0.5, 1),
    "& > div": {
        borderRadius: theme.kaltura.shape.roundness1,
    },
    "&:hover": {
        backgroundColor: "initial",
        "& > div": {
            backgroundColor: theme.kaltura.palette.tone6,
        },
    },
}));
